import { useStorefrontConfig } from '@graphcommerce/next-ui'
import Script from 'next/script'

export function GoogleAnalyticsScript() {
  const id = useStorefrontConfig().googleAnalyticsId ?? import.meta.graphCommerce.googleAnalyticsId
  return null
}
